module.exports = __webpack_public_path__ + "img/customers_apps@2x.5a4f91f4.png";